module.exports = __webpack_public_path__ + "media/images/kumu-step1-d44983d9c972b8587adbdad2e4f81dbb.png";